import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.472.809a2.76 2.76 0 0 0-3.905 0L1.62 11.755a.6.6 0 0 0-.158.27l-1.44 5.198a.613.613 0 0 0 .755.755l5.198-1.44a.6.6 0 0 0 .27-.157L17.192 5.434a2.764 2.764 0 0 0 0-3.905zM2.957 12.154l8.96-8.959 2.889 2.89-8.96 8.959zm-.578 1.158 2.309 2.309-3.193.885zm13.946-8.746-.651.65-2.89-2.889.651-.65a1.534 1.534 0 0 1 2.17 0l.72.72c.598.6.598 1.57 0 2.169"
    }, null, -1)
  ]))]))
}
export default { render: render }